var _style, _path, _defs, _path2, _path3, _ellipse, _defs2, _path4, _path5, _ellipse2, _defs3, _path6, _path7, _ellipse3, _defs4, _path8, _path9, _ellipse4, _defs5, _path0, _path1, _ellipse5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoyaBeans({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA7;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#FAC087;}\n\t.st2{clip-path:url(#SVGID_2_);fill:#F3914A;}\n\t.st3{fill:#FFE6C0;}\n\t.st4{clip-path:url(#SVGID_4_);fill:#FAC087;}\n\t.st5{clip-path:url(#SVGID_4_);fill:#F3914A;}\n\t.st6{clip-path:url(#SVGID_6_);fill:#FAC087;}\n\t.st7{clip-path:url(#SVGID_6_);fill:#F3914A;}\n\t.st8{clip-path:url(#SVGID_8_);fill:#FAC087;}\n\t.st9{clip-path:url(#SVGID_8_);fill:#F3914A;}\n\t.st10{clip-path:url(#SVGID_10_);fill:#FAC087;}\n\t.st11{clip-path:url(#SVGID_10_);fill:#F3914A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    transform: "matrix(0.3591 -0.9333 0.9333 0.3591 -3.3455 133.0971)",
    cx: 95.24,
    cy: 68.98,
    rx: 16.66,
    ry: 15.79
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FDD69C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.77,52.17c3.39,4.72,4.38,11.18,2.05,17.23c-3.58,9.3-13.62,14.09-22.44,10.7 c-0.19-0.07-0.37-0.15-0.55-0.23c1.83,2.54,4.35,4.57,7.43,5.75c8.81,3.39,18.86-1.4,22.44-10.7 C114.19,65.82,110.2,55.77,101.77,52.17z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.57,72.6c0,0-1.98-1.56-2.79-0.36c-0.81,1.2-1.91,3.48-3.31,4.99c-1.4,1.51-2.33,2.18-3.01,3.26 s-0.47,2.51,0.01,3.32c0.48,0.81,0.48,0.81,0.48,0.81s5.46-2.99,7.84-6.45C113.16,74.71,111.57,72.6,111.57,72.6z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.504 -0.8637 0.8637 0.504 -11.4568 111.0604)",
    className: "st3",
    cx: 90.97,
    cy: 65.51,
    rx: 6.71,
    ry: 4.19
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_3_",
    transform: "matrix(0.987 -0.1609 0.1609 0.987 -15.7149 13.6333)",
    cx: 76.34,
    cy: 103.88,
    rx: 15.79,
    ry: 16.66
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "#FDD69C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73.49,86.07c5.31,2.36,9.42,7.44,10.46,13.84c1.6,9.84-4.65,19.04-13.97,20.56c-0.2,0.03-0.4,0.06-0.6,0.08 c2.86,1.27,6.06,1.75,9.32,1.22c9.32-1.52,15.58-10.72,13.97-20.56C91.1,91.58,82.59,84.92,73.49,86.07z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M92.27,98.76c0,0-2.49-0.35-2.59,1.1c-0.1,1.44,0.11,3.96-0.34,5.98c-0.45,2.01-0.91,3.05-0.95,4.34 c-0.04,1.28,0.86,2.41,1.68,2.86c0.82,0.46,0.82,0.46,0.82,0.46s3.21-5.34,3.51-9.53C94.7,99.77,92.27,98.76,92.27,98.76z"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 70.9,
    cy: 103.03,
    rx: 4.19,
    ry: 6.71
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_5_",
    transform: "matrix(0.7962 -0.6051 0.6051 0.7962 -39.3942 87.6076)",
    cx: 110.34,
    cy: 102.28,
    rx: 16.66,
    ry: 15.79
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible",
      fill: "#FDD69C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M124.73,91.4c0.41,5.8-2.15,11.81-7.31,15.73c-7.93,6.03-19,4.82-24.71-2.7c-0.12-0.16-0.24-0.32-0.35-0.49 c0.22,3.12,1.3,6.17,3.29,8.8c5.71,7.52,16.78,8.73,24.71,2.7C128.12,109.55,130.01,98.9,124.73,91.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M122.33,113.94c0,0-0.86-2.37-2.19-1.78s-3.45,1.95-5.44,2.5c-1.99,0.55-3.13,0.63-4.27,1.19 c-1.15,0.57-1.72,1.89-1.74,2.83s-0.02,0.94-0.02,0.94s6.22,0.33,10.06-1.37S122.33,113.94,122.33,113.94z"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8828 -0.4697 0.4697 0.8828 -32.8772 62.3554)",
    className: "st3",
    cx: 108.53,
    cy: 97.07,
    rx: 6.71,
    ry: 4.19
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_7_",
    transform: "matrix(0.9678 -0.2517 0.2517 0.9678 -31.0229 29.543)",
    cx: 99.95,
    cy: 136.02,
    rx: 16.66,
    ry: 15.79
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible",
      fill: "#FDD69C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M117.42,131.52c-1.86,5.51-6.54,10.07-12.81,11.7c-9.64,2.51-19.39-2.87-21.77-12 c-0.05-0.19-0.09-0.39-0.14-0.59c-1,2.96-1.18,6.19-0.35,9.39c2.38,9.14,12.12,14.51,21.77,12 C113.56,149.57,119.4,140.48,117.42,131.52z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M106.52,151.4c0,0,0.11-2.52-1.33-2.48s-3.94,0.47-5.98,0.22c-2.05-0.26-3.13-0.63-4.41-0.54 c-1.28,0.08-2.32,1.08-2.7,1.94c-0.38,0.86-0.38,0.86-0.38,0.86s5.61,2.7,9.81,2.61C105.74,153.91,106.52,151.4,106.52,151.4z"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9956 -0.0935 0.0935 0.9956 -11.763 9.9479)",
    className: "st3",
    cx: 100.29,
    cy: 130.51,
    rx: 6.71,
    ry: 4.19
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_9_",
    transform: "matrix(0.3591 -0.9333 0.9333 0.3591 -11.3785 206.9634)",
    cx: 145.01,
    cy: 111.77,
    rx: 16.66,
    ry: 15.79
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible",
      fill: "#FDD69C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M151.53,94.95c3.39,4.72,4.38,11.18,2.05,17.23c-3.58,9.3-13.62,14.09-22.44,10.7 c-0.19-0.07-0.37-0.15-0.55-0.23c1.83,2.54,4.35,4.57,7.43,5.75c8.81,3.39,18.86-1.4,22.44-10.7 C163.96,108.6,159.97,98.56,151.53,94.95z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M161.34,115.38c0,0-1.98-1.56-2.79-0.36c-0.81,1.2-1.91,3.48-3.31,4.99s-2.33,2.18-3.01,3.26 s-0.47,2.51,0.01,3.32c0.48,0.81,0.48,0.81,0.48,0.81s5.46-2.99,7.84-6.45S161.34,115.38,161.34,115.38z"
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.504 -0.8637 0.8637 0.504 -23.7221 175.2675)",
    className: "st3",
    cx: 140.74,
    cy: 108.29,
    rx: 6.71,
    ry: 4.19
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoyaBeans);
export default __webpack_public_path__ + "static/media/Soya_beans.9b582ac04cf2449150287c87fc87fc17.svg";
export { ForwardRef as ReactComponent };